import styled from 'styled-components'

export const IconWrapper = styled.div`
  position: relative;
  width: ${(props) => props.size}px;
`

export const Spacer = styled.div`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`
